import { Component } from 'react'
import PropTypes from 'prop-types'

class ErrorBoundary extends Component {
    constructor(props) {
        super(props)

        this.state = {
            hasError: false,
        }
    }

    componentDidCatch(error, info) {
        this.setState({
            hasError: true,
        })

        console.info(
            `Encountered an error when trying to display ServerMenu... | Message: ${error} | StackTrace: ${JSON.stringify(
                info,
            )}`,
        )
    }

    render() {
        if (this.state.hasError) {
            return null
        }

        return this.props.children
    }
}

ErrorBoundary.propTypes = {
    children: PropTypes.node,
}

export default ErrorBoundary



// WEBPACK FOOTER //
// ./src/features/ServerMenu/error/index.js